
export class Atgardstyper {
// eslint-disable-next-line sonarjs/public-static-readonly
    static GallringOspecificerad = "G ospec";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Kvalitetsgallring = "G kval";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Laggallring = "G lag";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Hushallsgallring = "G hush";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Klengallring = "G klen";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static UtglesningFS = "Utgl F/S";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static AvvecklingFS = "Avv F/S";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Plockhuggning = "Plockh";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Bladning = "Blädn";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static VindSkada = "Vind/Skada";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static VagLedning = "Väg/Ledn";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static NSFrihuggning = "NS-Frihuggning";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static NSUtglesning = "NS-Utglesning";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static NSLuckhuggning = "NS-Luckhuggning";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static NSRestavv = "NS-Restavv";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Foryngringsavverkning = "Favv";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static ForyngringsavverkningTillFrotrad = "Favv F";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static ForyngringsavverkningTillSkarm = "Favv S";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Kanthuggning = "Kanth";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Luckhuggning = "Luckh";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static FrakAvv = "Frak-avv";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Grot = "Grot";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Energived = "Energived";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static BiobransleLangsVag = "Biobr väg";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Leveransvirke = "Leveransvirke";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static SkadaPlockhuggning = "Skada Plockh";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static SchackruteavverkningHF = "Schack-avv";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static BladningHF = "Bladn HF";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static PlockhuggningHF = "Plockh HF";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static AvverkningtillskarmHF = "Avv S HF";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static UtglesningavskarmHF = "HF-Utglesning";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static AvvecklingavskarmHF = "HF-Avveckling";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static GallringHF = "Gall-HF";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static KanthuggningHF = "Kanthuggning HF";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static LuckhuggningHF = "Luckhuggning HF";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Skogsvard = "Skogsvard";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static alla = [
        Atgardstyper.GallringOspecificerad,
        Atgardstyper.Kvalitetsgallring,
        Atgardstyper.Laggallring,
        Atgardstyper.Hushallsgallring,
        Atgardstyper.Klengallring,
        Atgardstyper.UtglesningFS,
        Atgardstyper.AvvecklingFS,
        Atgardstyper.Plockhuggning,
        Atgardstyper.Bladning,
        Atgardstyper.VindSkada,
        Atgardstyper.VagLedning,
        Atgardstyper.NSFrihuggning,
        Atgardstyper.NSUtglesning,
        Atgardstyper.NSLuckhuggning,
        Atgardstyper.NSRestavv,
        Atgardstyper.Foryngringsavverkning,
        Atgardstyper.ForyngringsavverkningTillFrotrad,
        Atgardstyper.ForyngringsavverkningTillSkarm,
        Atgardstyper.Kanthuggning,
        Atgardstyper.Luckhuggning,
        Atgardstyper.FrakAvv,
        Atgardstyper.Grot,
        Atgardstyper.Energived,
        Atgardstyper.BiobransleLangsVag,
        Atgardstyper.Leveransvirke,
        Atgardstyper.SkadaPlockhuggning,
        Atgardstyper.SchackruteavverkningHF,
        Atgardstyper.BladningHF,
        Atgardstyper.PlockhuggningHF,
        Atgardstyper.AvverkningtillskarmHF,
        Atgardstyper.UtglesningavskarmHF,
        Atgardstyper.AvvecklingavskarmHF,
        Atgardstyper.GallringHF,
        Atgardstyper.KanthuggningHF,
        Atgardstyper.LuckhuggningHF
    ];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static foryngringsavverkningstyper = [
        Atgardstyper.Foryngringsavverkning,
        Atgardstyper.ForyngringsavverkningTillFrotrad,
        Atgardstyper.ForyngringsavverkningTillSkarm,
        Atgardstyper.Kanthuggning,
        Atgardstyper.Luckhuggning,
        Atgardstyper.FrakAvv
    ];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static markberedningbForyngringTyper = [
        Atgardstyper.Foryngringsavverkning,
        Atgardstyper.ForyngringsavverkningTillFrotrad,
        Atgardstyper.ForyngringsavverkningTillSkarm,
        Atgardstyper.VagLedning,
        Atgardstyper.Kanthuggning,
        Atgardstyper.FrakAvv,
        Atgardstyper.Luckhuggning,
        Atgardstyper.VindSkada,
        Atgardstyper.NSFrihuggning,
        Atgardstyper.NSUtglesning,
        Atgardstyper.NSLuckhuggning,
        Atgardstyper.NSRestavv
    ];

    // Alla åtgärdstyper som hanterar och ska avverkningsanmälas
    // eslint-disable-next-line sonarjs/public-static-readonly
    static avvAnmalanTyper = [
        Atgardstyper.VagLedning,
        Atgardstyper.UtglesningFS,
        Atgardstyper.VindSkada,
        Atgardstyper.NSFrihuggning,
        Atgardstyper.NSUtglesning,
        Atgardstyper.NSLuckhuggning,
        Atgardstyper.NSRestavv,
        Atgardstyper.Foryngringsavverkning,
        Atgardstyper.ForyngringsavverkningTillFrotrad,
        Atgardstyper.ForyngringsavverkningTillSkarm,
        Atgardstyper.Kanthuggning,
        Atgardstyper.Luckhuggning,
        Atgardstyper.FrakAvv
    ];
}
